import {
  IonButton,
  IonButtons,
  IonContent,
  IonHeader,
  IonIcon,
  IonModal,
  IonPage,
  IonTitle,
  IonToolbar,
  useIonToast
} from "@ionic/react";
import { useHistory, useLocation } from "react-router";
import {
  getEmailValidationSchema,
  getPasswordValidationSchema
} from "../components/forms/getValidationSchema";
import { sendPasswordReset, signInWithEmail } from "../lib/firebase";
import validate from "../components/forms/validate";
import { Form, Formik } from "formik";
import TextInput from "../components/forms/TextInput";
import { arrowBack, closeCircleOutline } from "ionicons/icons";
import { useEffect, useRef } from "react";
import AnimationContainer from "../components/Animation";

const Password: React.FC = () => {
  const location: any = useLocation();
  const history = useHistory();
  const modal = useRef<HTMLIonModalElement>(null);
  const [present] = useIonToast();

  const email = location?.state?.email;
  useEffect(() => {
    if (!email) {
      history.replace("/auth");
    }
    // eslint-disable-next-line
  }, []);

  const submitForm = async (values: any, { setSubmitting }: any) => {
    const { password } = values;
    const feedback = await signInWithEmail(email, password);
    console.log(feedback);
    if (feedback === "success") {
      history.replace("/dashboard");
    } else if (feedback === "wrong-password") {
      present({
        message: "Wrong password. Please try again.",
        color: "dark",
        cssClass: "text-lg",
        buttons: [
          {
            icon: closeCircleOutline,
            role: "cancel"
          }
        ]
      });
    }
    setSubmitting(false);
  };

  const passwordReset = async () => {
    await sendPasswordReset(email);
    present({
      message: "An email has been sent to the associated address",
      position: "bottom",
      color: "dark",
      cssClass: "text-lg",
      buttons: [
        {
          icon: closeCircleOutline,
          role: "cancel",
          handler: () => {
            modal.current?.dismiss();
          }
        }
      ]
    });
  };

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonButtons slot="start">
            <IonButton color="dark" onClick={() => history.goBack()}>
              <IonIcon icon={arrowBack} />
            </IonButton>
          </IonButtons>
          <IonTitle>Welcome Back!</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent fullscreen>
        <div className="max-w-lg mx-auto">
          <AnimationContainer animationName="safeAnimation" />
          <Formik
            initialValues={{ password: "" }}
            validate={validate(getPasswordValidationSchema)}
            onSubmit={submitForm}
          >
            {({ isSubmitting, errors, isValid }) => (
              <Form>
                <div className="pt-12">
                  {/* TODO: Show password */}
                  <TextInput
                    name="password"
                    label="Password:"
                    placeholder="Password"
                    type="password"
                  />
                  <IonButton
                    expand="block"
                    color="primary"
                    type="submit"
                    className="mx-6 mt-6 h-12 normal-case"
                    disabled={isSubmitting || !isValid}
                  >
                    Continue
                  </IonButton>
                  <div className="text-base justify-center h-1/3 flex items-end">
                    <IonButton
                      fill="clear"
                      color="dark"
                      className="underline"
                      id="open-modal"
                    >
                      {"Forgotten Password"}
                    </IonButton>
                  </div>
                </div>
              </Form>
            )}
          </Formik>
        </div>
        <IonModal ref={modal} trigger="open-modal">
          <IonContent>
            <div>
              <IonButton
                color="dark"
                fill="clear"
                onClick={() => modal.current?.dismiss()}
              >
                <IonIcon icon={closeCircleOutline} />
              </IonButton>
            </div>
            <div className="px-8">
              Enter the email address associated with your account, and we'll
              email you a link to reset your password
            </div>
            <Formik
              initialValues={{ email }}
              validate={validate(getEmailValidationSchema)}
              onSubmit={passwordReset}
            >
              {({ isSubmitting, errors, isValid }) => (
                <Form>
                  <div className="pt-4">
                    <TextInput
                      name="email"
                      label="Email:"
                      placeholder="Email Address"
                      type="email"
                    />
                    <IonButton
                      expand="block"
                      color="primary"
                      type="submit"
                      className="mx-6 mt-6 h-12 normal-case"
                      disabled={isSubmitting || !isValid}
                    >
                      Continue
                    </IonButton>
                  </div>
                </Form>
              )}
            </Formik>
          </IonContent>
        </IonModal>
      </IonContent>
    </IonPage>
  );
};

export default Password;
